import { useSelector } from 'react-redux';
import { STORE_NAME, ToastStorage } from './private';

export function useToastMessages(): ToastStorage {
    const messages = useSelector(globalState => (globalState as any)[STORE_NAME] ?? []);

    if (!messages) {
        throw new Error(`Missing ${STORE_NAME} value`);
    }

    return messages;
}
